import { Component, inject } from '@angular/core';

import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import {
  RdsDialogModule,
  RdsButtonModule,
  RdsFormFieldModule,
  RdsDialogRef,
  RDS_DIALOG_DATA,
  RdsIconsModule,
} from '@rds/angular-components';
import { BUTTON_TEXTS } from '../../../../constants/buttons.constants';
import { ERRORS_TEXTS } from '../../../../constants/errors.contstants';
import { KnowledgeSuccessStory } from '../../../../models/knowledge';
import { RichTextEditorComponent } from '../../../shared/rich-text-editor/rich-text-editor.component';
import { POPUPS } from '../../../../constants/popups.constants';

@Component({
  selector: 'inexp-focus-success-story-dialog',
  imports: [
    ReactiveFormsModule,
    RdsDialogModule,
    RdsButtonModule,
    RdsIconsModule,
    RdsFormFieldModule,
    RichTextEditorComponent,
  ],
  templateUrl: './focus-success-story-dialog.component.html',
  styleUrl: './focus-success-story-dialog.component.scss',
})
export class FocusSuccessStoryDialogComponent {
  private readonly _fb = inject(FormBuilder);
  private readonly _dialogRef =
    inject<RdsDialogRef<FocusSuccessStoryDialogComponent>>(RdsDialogRef);
  protected readonly data = inject(RDS_DIALOG_DATA) as {
    successStories?: KnowledgeSuccessStory;
  };
  readonly ERRORS = ERRORS_TEXTS;
  readonly BUTTONS = BUTTON_TEXTS;
  readonly POPUPS = POPUPS;

  form = this._fb.group({
    title: [this.data.successStories?.title ?? '', Validators.required],
    description: [
      this.data.successStories?.description ?? '',
      [Validators.required],
    ],
  });

  submit() {
    if (this.form.valid) {
      this._dialogRef.close(this.form.value);
    } else {
      this.form.markAllAsTouched();
    }
  }
}
